// src/utils/mixpanel.js
import mixpanel from "mixpanel-browser";

mixpanel.init("b4f67ef9e82d1f989afa7905425c4e5a");

export default mixpanel;
